export default __webpack_public_path__ + "resources/icons/d130-5f80.png";